export default __webpack_public_path__ + "assets/images/4fd7e31120f1cecf46d9995e433f637c.svg";